
export const scrollToTop = () => {window.scrollTo({ top: 0, behavior: 'smooth' })}

export const createLoadingGuard = () => {
  let timeoutId: any = null;
  let isFinished = true; // Trạng thái mặc định là đã xong (không có delay)
  const queue: Array<() => void> = [];

  const addDelay = (time: number) => {
    // 1. Dọn dẹp ngay lập tức để giải phóng tài nguyên
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    isFinished = false;
    queue.length = 0; 

    timeoutId = setTimeout(() => {
      isFinished = true;
      timeoutId = null;
      
      // Thực thi nhanh hàng đợi bằng vòng lặp thay vì tạo mảng mới
      while (queue.length > 0) {
        const cb = queue.shift();
        if (cb) cb();
      }
    }, time);
  };

  const removeDelay = (callback: () => void) => {
    if (isFinished) {
      callback(); // Chạy ngay, cực nhẹ vì không dính tới async/await
    } else {
      queue.push(callback); // Thêm vào hàng đợi, tốn rất ít RAM
    }
  };

  const clearDelay = () => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = null;
    isFinished = true;
    queue.length = 0;
  };

  return { 
      startGuard: addDelay,
      endGuard: removeDelay,
      cancelGuard: clearDelay
  };
};

export const createPaginationDisplay = () => {
  const getVisiblePages = (totalPages: number, currentPage: number, maxVisiblePages: number) => {
    const total = Math.max(Number(totalPages || 1), 1)
    const current = Math.min(Math.max(Number(currentPage || 1), 1), total)
    const maxVisible = Math.max(Number(maxVisiblePages || 1), 1)
  
    if (total <= maxVisible) return Array.from({ length: total }, (_, idx) => idx + 1)
  
    const half = Math.floor(maxVisible / 2)
    let start = current - half
    let end = current + half
  
    if (start < 1) {
      start = 1
      end = maxVisible
    } else if (end > total) {
      end = total
      start = total - maxVisible + 1
    }
  
    return Array.from({ length: end - start + 1 }, (_, idx) => start + idx)
  };

  const showFirstPage = (visiblePages: Array<number>) => {
    return visiblePages && visiblePages.at(0) > 1
  };

  const showFirstEllipsis = (visiblePages: Array<number>) => {
    return visiblePages && visiblePages.at(0) > 2
  };

  const showLastPage = (visiblePages: Array<number>, totalPages: number) => {
    return visiblePages && visiblePages.at(-1) < totalPages
  };

  const showLastEllipsis = (visiblePages: Array<number>, totalPages: number) => {
    return visiblePages && visiblePages.at(-1) < totalPages - 1
  };

  return { getVisiblePages, showFirstPage, showFirstEllipsis, showLastPage, showLastEllipsis };
}